var moduleMap = {
	"./diContainer": () => {
		return Promise.all(/* diContainer */[__webpack_require__.e("vendors-node_modules_estee_elc-formatters_src_business-unit-id-parser_BusinessUnitIdParser_ts-88214a"), __webpack_require__.e("diContainer")]).then(() => (() => ((__webpack_require__("./src/service-setup/diContainer.ts")))));
	},
	"./account-sidebar-loyalty": () => {
		return Promise.all(/* account-sidebar-loyalty */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("account-sidebar-loyalty")]).then(() => (() => ((__webpack_require__("./src/exported/loyalty-tier/index.ts")))));
	},
	"./loyalty-points-info": () => {
		return Promise.all(/* loyalty-points-info */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("loyalty-points-info")]).then(() => (() => ((__webpack_require__("./src/exported/loyalty-points-info/index.ts")))));
	},
	"./loyalty-tier-info": () => {
		return Promise.all(/* loyalty-tier-info */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("loyalty-tier-info")]).then(() => (() => ((__webpack_require__("./src/exported/loyalty-tier-info/index.ts")))));
	},
	"./loyalty-dashboard": () => {
		return Promise.all(/* loyalty-dashboard */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("loyalty-dashboard")]).then(() => (() => ((__webpack_require__("./src/exported/loyalty-dashboard/index.ts")))));
	},
	"./loyalty-submit-receipt": () => {
		return Promise.all(/* loyalty-submit-receipt */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("loyalty-submit-receipt")]).then(() => (() => ((__webpack_require__("./src/exported/loyalty-submit-a-receipt/index.ts")))));
	},
	"./loyalty-earn-points": () => {
		return Promise.all(/* loyalty-earn-points */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("loyalty-earn-points")]).then(() => (() => ((__webpack_require__("./src/exported/loyalty-earn-points/index.ts")))));
	},
	"./loyalty-points-history": () => {
		return Promise.all(/* loyalty-points-history */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("loyalty-points-history")]).then(() => (() => ((__webpack_require__("./src/exported/loyalty-points-history/index.ts")))));
	},
	"./loyalty-benefits": () => {
		return Promise.all(/* loyalty-benefits */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("loyalty-benefits")]).then(() => (() => ((__webpack_require__("./src/exported/loyalty-benefits/index.ts")))));
	},
	"./loyalty-rewards": () => {
		return Promise.all(/* loyalty-rewards */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("loyalty-rewards")]).then(() => (() => ((__webpack_require__("./src/exported/loyalty-rewards/index.ts")))));
	},
	"./loyalty-marketing-point-benefit": () => {
		return Promise.all(/* loyalty-marketing-point-benefit */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("loyalty-marketing-point-benefit")]).then(() => (() => ((__webpack_require__("./src/exported/loyalty-marketing-point-benefit/index.ts")))));
	},
	"./loyalty-birthday": () => {
		return Promise.all(/* loyalty-birthday */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("loyalty-birthday")]).then(() => (() => ((__webpack_require__("./src/exported/loyalty-birthday/index.ts")))));
	},
	"./loyalty-marketing-page": () => {
		return Promise.all(/* loyalty-marketing-page */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("loyalty-marketing-page")]).then(() => (() => ((__webpack_require__("./src/exported/loyalty-marketing-page/index.ts")))));
	},
	"./loyalty-landing-page": () => {
		return Promise.all(/* loyalty-landing-page */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("loyalty-landing-page")]).then(() => (() => ((__webpack_require__("./src/exported/loyalty-landing-page/index.ts")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});